import { OptionButton, OptionButtonProps } from "./OptionButton/OptionButton";
import { OptionResult, OptionResultProps } from "./OptionResult/OptionResult";

export { OptionButton, OptionButtonProps, OptionResult, OptionResultProps };
